import * as React from 'react';
import { attachBehaviors } from './BehaviorsHelper';
import { CalendarDayContentConfig } from '../interfaces/CalendarDayConfig';
import { logMountingPerformance } from 'owa-analytics';
import { observer } from 'mobx-react';

let styles = require('./CalendarDayList.scss');
let classNames = require('classnames/bind').bind(styles);

/**
 * Props for calendar all day well
 */
export interface CalendarAllDayWellProps {
    config: CalendarDayContentConfig;
    className: string;
}

/**
 * The control is showing calendar all day events
 */
@logMountingPerformance('CalendarAllDayWell')
@observer
export default class CalendarAllDayWell extends React.Component<CalendarAllDayWellProps, {}> {
    render() {
        const numberOfVisibleAllDayItems = 4;
        let { config, className } = this.props;
        let surfaceAllDayItems = config.content.allDayContent();
        let allDayPanelClasses = classNames(className, 'customScrollBar');
        let itemsProvider = surfaceAllDayItems[surfaceAllDayItems.length - 1].props.itemsProvider;
        let numberOfAllDayRows = itemsProvider ? itemsProvider.allDayRows.length : 0;
        let style = {
            height: numberOfAllDayRows > numberOfVisibleAllDayItems ? '100%' : 'auto',
        };

        return attachBehaviors(
            <div className={allDayPanelClasses} key="alldaypanel_1" data-is-scrollable={true}>
                <div className={styles.renderAllDayPanel} style={style}>
                    {surfaceAllDayItems}
                </div>
            </div>,
            config.allDayBehaviors
        );
    }
}
